import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
export function getNumberFieldWidth(value) {
  return 50 + (value ? value.toString().length - 1 : 0) * 10;
}